/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import SelectBranchForTeacher from "./SelectBranchForTeacher.jsx";
import SelectRoleForTeacher from "./SelectRoleForTeacher.jsx";
import { hitApi } from "../utils/apiCall.js";
import { Link, useNavigate } from "react-router-dom";
import accessDenied from "../pages/assets/accessDenied.png";

const mId = 13;
const sId = 1; // Student Attendance ID

function TeacherAttendanceForm() {
  const navigate = useNavigate()
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [branchKeys, setBranchKeys] = useState([]);
  const [roleKeys, setRoleKeys] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [branchFromComp, setBranchfromComp] = useState([]);
  const [roleFromComp, setRolefromComp] = useState([]);
  const [access, setAccess] = useState({});
  const [stepValidations, setStepValidations] = useState([false, false]);
  const [loadingAccess, setLoadingAccess] = useState(true);


useEffect(() => {
  async function getAccessDetails() {
    setLoadingAccess(true); // start loader
    const fd = new FormData();
    fd.append("subMenu", sId);
    fd.append("menuId", mId);
    const res = await hitApi("permission/permission", "getAccessDetails", fd);
    if (res.success) {
      setAccess(res.data[0]);
    } else {
      setAccess({});
    }
    setLoadingAccess(false); // stop loader
  }
  getAccessDetails();
}, []);


  const steps = [
    <SelectBranchForTeacher setBranchfromComp={setBranchfromComp} key="branch" />,
    <SelectRoleForTeacher setRolefromComp={setRolefromComp} key="role" />,
  ];

  // Sync selected keys from localStorage on mount
  useEffect(() => {
    const storedBranch = JSON.parse(localStorage.getItem("branchForTeacher")) || {};
    const storedRole = JSON.parse(localStorage.getItem("role")) || {};

    const selectedBranches = Object.keys(storedBranch).filter((key) => storedBranch[key]);
    const selectedRoles = Object.keys(storedRole).filter((key) => storedRole[key]);

    setBranchKeys(selectedBranches);
    setRoleKeys(selectedRoles);
  }, []);

  // Validate form steps
  useEffect(() => {
    let selectedBranches = [];
    let selectedRoles = [];

    if (Object.keys(branchFromComp || {}).length > 0) {
      selectedBranches = Object.keys(branchFromComp).filter(key => branchFromComp[key]);
    } else {
      const storedBranch = JSON.parse(localStorage.getItem("branchForTeacher")) || {};
      selectedBranches = Object.keys(storedBranch).filter(key => storedBranch[key]);
    }

    if (Object.keys(roleFromComp || {}).length > 0) {
      selectedRoles = Object.keys(roleFromComp).filter(key => roleFromComp[key]);
    } else {
      const storedRole = JSON.parse(localStorage.getItem("role")) || {};
      selectedRoles = Object.keys(storedRole).filter(key => storedRole[key]);
    }

    setStepValidations([
      selectedBranches.length > 0,
      selectedRoles.length > 0,
    ]);

    setIsFormValid(
      selectedBranches.length > 0 && selectedRoles.length > 0
    );

    setBranchKeys(selectedBranches);
    setRoleKeys(selectedRoles);
  }, [branchFromComp, roleFromComp]);


  function next() {
    if (currentStepIndex < steps.length - 1) {
      setCurrentStepIndex((i) => i + 1);
    }
  }

  function back() {
    if (currentStepIndex > 0) {
      setCurrentStepIndex((i) => i - 1);
    }
  }

  const currentStep = steps[currentStepIndex];

  return (
    <>
      {loadingAccess ? (
      // Show loader while checking access
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    ) : access?.is_view === "1" ? (

        <div className="page-content-wrapper " style={{marginTop:"0"}}>

          {/* Header with back button */}
          <div className="d-flex align-items-center px-3  bg-white border-bottom  p-2">
            <button
              className="btn btn-link text-primary p-2 me-2"
              onClick={() => navigate(-1)}
              style={{ fontSize: "20px" }}
            >
              <i className="bi bi-arrow-left"></i>
            </button>
            <h6 className="m-0">Select Role & Branch</h6>
          </div>
          <div className="container " style={{ marginTop: "2rem" }}>
            {currentStep}
          </div>

          <div
            style={{ bottom: "0%" }}
            className="position-fixed  bg-white w-100 g-0 row p-2"
          >
            <div className="col-6 text-center">
              {currentStepIndex > 0 && (
                <button
                  onClick={back}
                  className="btn btn-primary"
                  style={{ width: "95%" }}
                >
                  Prev
                </button>
              )}
            </div>

            <div className="col-6 text-center  ">
              {currentStepIndex < steps.length - 1 ? (
                <button
                  onClick={next}
                  className="btn btn-primary"
                  style={{ width: "95%" }}
                  disabled={!stepValidations[currentStepIndex]}
                >
                  Next
                </button>
              ) : isFormValid ? (
                <Link
                  style={{ width: "95%" }}
                  to="/teacher-attendance"
                  className="btn btn-primary"
                >
                  Proceed
                </Link>
              ) : (
                <button
                  style={{ width: "95%" }}
                  className="btn btn-secondary"
                  disabled
                >
                  Select all fields
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
      // No Access
      <div className="page-content-wrapper">
        <div className="container p-1" style={{ marginTop: "2rem" }}>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img src={accessDenied} alt="No Access" />
            <br />
            <h1>No access</h1>
          </div>
        </div>
      </div>
    )}
  </>
  );
}

export default TeacherAttendanceForm;
